import { environment } from "src/environments/environment";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { LocalCookiesService } from "../conta/services/local-cookie.service";
import { Injectable, OnInit } from "@angular/core";
import { Observable } from "rxjs";
import { ResponseModel } from "../models/response.model";
import { map } from "rxjs/operators";
@Injectable()
export abstract class BaseService implements OnInit {
    private apiUrl;
    private requestOptions;
    /**
     *
     */
    constructor(private localCookieService: LocalCookiesService,
        private http: HttpClient) {
            this.apiUrl = environment.apiUrl;
            this.requestOptions = this.obterRequestOptions(this.localCookieService.obterAccessToken());
           
    }
    ngOnInit(): void {

        
    }
    private obterRequestOptions(token: string) {
        let result = {
            headers: new HttpHeaders({
                
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            })
        };
        return result;
    }
    protected get(url: string):Observable<any> {
 
        var result = this.http.get<ResponseModel>(this.apiUrl+url, this.requestOptions)
        return result;          
    }
   
    protected post(url:string,data:any):Observable<any>
    {
        var result= this.http.post(this.apiUrl+url,data,this.requestOptions);
        return result;
    }

    protected put(url:string,data:any):Observable<any>
    {
        var result= this.http.put(this.apiUrl+url,data,this.requestOptions);
        return result;
    }
    //TODO: CRUD
}